module.exports = __webpack_public_path__ + "static/media/fleche-droit.a1ed9620.svg";